// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  fetchAndSetProjectCompanies,
  addPathToProjectSummary,
  updatePathInProjectSummary,
} from 'redux/modules/projectSummary'

// if we're within the project summary view, update redux state to
// reflect the new changes that were just made to the project's paths

const updateProjectSummary = (entity, isNewPath) => async (dispatch, getState) => {
  const withinProjectSummary = getState().pathDetails.get('withinProjectSummary')
  const {
    pathId,
    projectId,
  } = entity

  if (!withinProjectSummary) {
    return
  }

  // update redux state to track the new changes that were just applied
  if (isNewPath) {
    await dispatch(addPathToProjectSummary(pathId))
  } else {
    await dispatch(updatePathInProjectSummary(pathId))
  }

  await dispatch(fetchAndSetProjectCompanies(projectId))
}

export default updateProjectSummary
